"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Observable = void 0;
var Utilities_1 = require("../Utilities");
var Subscribable_1 = require("./Subscribable");
var ReadonlyObservableProxy = /** @class */ (function () {
    function ReadonlyObservableProxy(observable) {
        this._observable = observable;
    }
    ReadonlyObservableProxy.prototype.subscribe = function (handler) {
        return this._observable.subscribe(handler);
    };
    Object.defineProperty(ReadonlyObservableProxy.prototype, "value", {
        get: function () {
            return this._observable.value;
        },
        enumerable: false,
        configurable: true
    });
    return ReadonlyObservableProxy;
}());
function safeCompare(a, b, equalityComparer) {
    if (((0, Utilities_1.isNullOrUndefined)(a) && !(0, Utilities_1.isNullOrUndefined)(b)) || ((0, Utilities_1.isNullOrUndefined)(b) && !(0, Utilities_1.isNullOrUndefined)(a))) {
        return false;
    }
    return equalityComparer(a, b);
}
var defaultEqualityComparer = function (a, b) { return a === b; };
var Observable = /** @class */ (function () {
    function Observable(initialValue, equalityComparer) {
        if (equalityComparer === void 0) { equalityComparer = defaultEqualityComparer; }
        this._subscribable = new Subscribable_1.Subscribable();
        this._value = initialValue;
        this._equalityComparer = equalityComparer;
    }
    Object.defineProperty(Observable.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            var valueChanged = !safeCompare(this._value, value, this._equalityComparer);
            if (valueChanged) {
                this._value = value;
                this._subscribable.notifySubscribers(this._value);
            }
        },
        enumerable: false,
        configurable: true
    });
    Observable.prototype.subscribe = function (handler) {
        return this._subscribable.subscribe(handler);
    };
    Observable.prototype.asReadonly = function () {
        if (!this._readonlyProxy) {
            this._readonlyProxy = new ReadonlyObservableProxy(this);
        }
        return this._readonlyProxy;
    };
    Observable.prototype.dispose = function () {
        // @ts-ignore -- TODO: keeping to ensure back-compat (did this to help the GC, but it's probably not necessary)
        delete this._value;
        delete this._readonlyProxy;
        this._subscribable.dispose();
    };
    return Observable;
}());
exports.Observable = Observable;
//# sourceMappingURL=Observable.js.map